import React, { useEffect, useState } from 'react';
import { ButtonBlockPrimary, LayoutLearning } from '../../../components';
import { Tlearning, initialLearning } from '../../../type/learning';
import { useNavigate, useParams } from 'react-router-dom';
import { getDataDetail } from '../../../service/learningService';
import YouTube from 'react-youtube';
import DynamicFaIcon from '../../../components/atoms/DynamicFaIcon';
import { formatDuration } from '../../../utls/date';
import { postData } from '../../../service/learningUsersService';
import { getMyProfile } from '../../../service/usersService';
import { Tusers, initialUsers } from '../../../type/users';
import { FaLock } from 'react-icons/fa6';
import { MINIO } from '../../../data/data';

const LearningDetail = () => {
	const [user, setUser] = useState<Tusers>(initialUsers);
	const [learning, setLearning] = useState<Tlearning>(initialLearning);
	const [isGotAccess, setIsGotAccess] = useState<boolean>(false);
	const [back, setBack] = useState<boolean>(true);
	const [duration, setDuration] = useState(0);

	const { slug } = useParams();
	const navigate = useNavigate();

	const getMyDataProfile = async () => {
		const response = await getMyProfile();
		if (!response?.error) {
			setUser(response?.data);
		}
	};

	const getDataLearningDetail = async (slug: string) => {
		const response = await getDataDetail(slug);
		if (!response?.error) {
			setLearning(response?.data);
			getMyDataProfile();
		}
	};

	useEffect(() => {
		getDataLearningDetail(slug || '');
	}, []);

	useEffect(() => {
		const learningAccess: string[] = [];

		learning.learningAccesses.map((item, index) => {
			learningAccess.push(item.memberType.code);
		});

		// Check access
		if (user.memberType?.code) {
			setIsGotAccess(learningAccess.includes(user.memberType.code));
		}
	}, [user]);

	const opts = {
		height: '300',
		width: '100%',
		playerVars: {
			controls: 1,
			rel: 0,
		},
	};

	const onJoin = async () => {
		const data = {
			learning: learning,
		};
		const response = await postData(data);
		if (response?.code === 200 && !response?.error) {
			if (response.data.access) {
				navigate(`/admin/learning/prosess/${learning.uniqueId}`);
				return;
			}

			if (response.data.block) {
				navigate(`/admin/learning/confirm/block/${learning.slug}`);
				return;
			}
			navigate(`/admin/learning/confirm/waiting/${learning.slug}`);
		}
	};

	return (
		<LayoutLearning btnBack={back}>
			{learning?.learningAssetsVideos.length > 0 && (
				<div className="min-w-full max-h-[360px] overflow-hidden">
					<img
						src={`${MINIO}/${learning.thumbnail}`}
						className="w-full object-cover"
						alt={learning.name}
					/>
					{/* <YouTube
						className=""
						onPlay={(event: any) => {
							setBack(false);
						}}
						onReady={(event: any) => {
							setDuration(event.target.getDuration());
						}}
						onPause={() => {
							setBack(true);
						}}
						opts={opts}
						onPlaybackRateChange={(event: any) => {}}
						videoId={learning.learningAssetsVideos[0].youtubeId}
					/> */}
				</div>
			)}

			<div className="mx-4 mt-[1rem] background-img">
				<h1 className="text-[16px]">{learning.name}</h1>
				<div className="flex items-center justify-between text-[12px] text-sky-600 my-[.5rem]">
					<div className="flex items-center gap-2">
						<DynamicFaIcon name={'FaVolumeHigh'} />
						<span className="">{learning.author}</span>
					</div>

					<div>{formatDuration(duration)}</div>
				</div>
				<div
					className="line-clamp-[10] mb-[1rem]"
					dangerouslySetInnerHTML={{ __html: learning.content }}
				/>

				{isGotAccess ? (
					<ButtonBlockPrimary
						label={'Belajar Sekarang'}
						onClick={() => {
							onJoin();
						}}
					/>
				) : (
					<button
						disabled={isGotAccess}
						className="btn btn-block bg-slate-600 text-white"
					>
						<div className="flex items-center gap-3 justify-center hover:cursor-not-allowed">
							Belajar Sekarang <FaLock />
						</div>
					</button>
				)}
			</div>
		</LayoutLearning>
	);
};

export default LearningDetail;
